import { useState, useEffect, useMemo, useRef } from "react";

import Pagination from "controls/Pagination";
import CartItem from "./CartItem";
import CartDelivery from "./CartDelivery";
import CartPayment from "./CartPayment";
import CartTotal from "./CartTotal";
import CartPreview from "./CartPreview";
import CartService from "api/precision/CartService";
import ConfirmModal from "controls/ConfirmModal";
import ConfirmToast from "controls/ConfirmToast";
import { money } from "common/functions"
import 'styles/scora.css';

/**
 * Cart Item - {
 *   "id": res.data.data,
 *   "user_id": props.user.id,
 *   "product_id": props.product.id,
 *   "product_name": props.product.name,
 *   "quantity": preorderInfo.quantity
 * }
 */
export default function OrderConfirmed(props) {
    document.title = 'Shopping Cart';

    const { getProfile, getCustomer } = props.useSession();
    const { navigate, location } = props.useRouter();

    // cart, delivery, payment, preview
    const hash = location.hash !== "" ? location.hash.substring(1) : "cart";

    useEffect(() => {

    }, []);

    const cartHeader = useMemo(() => {
        let cartTitle = "Shopping cart";
        if (hash == "preview") {
            cartTitle = "Order preview";
        }
        else if (hash == "delivery") {
            cartTitle = "Delivery information";
        }
        else if (hash == "payment") {
            cartTitle = "Payment information";
        }
        else if (hash == "preview") {
            cartTitle = "Order preview";
        }

        return <section className="d-flex justify-content-between align-items-center p-3 bg-secondary-subtle shadow">
            <h1 className="ps-5" style={{ fontSize: "35px" }}>{cartTitle}</h1>
        </section>
    });

    return (
        <div className="">
            <section className="hero_section">
                <div className="mx-md-auto">
                    <h1 style={{ width: '875px' }}>Checkout</h1>
                </div>
            </section>

            <div className="px-5" style={{ width: '100vw' }}>
                <section className="d-flex flex-column mt-5 mb-4 mx-auto" style={{ maxWidth: '875px' }}>
                    <h2 className="text-black fs-4 fst-normal" style={{ fontWeight: '700' }}>Your Order is Confirmed!</h2>
                    <p className="text-secondary fs-4" style={{ fontWeight: '400' }}>
                        Thank you for choosing SCORA-approved canoe numbers, produced in partnership with 
                        Precision Services Group (PSG). Your order is being processed, and you'll receive 
                        a confirmation email with your order details shortly.
                    </p>
                    <h2 className="text-black fs-4 fst-normal" style={{ fontWeight: '700' }}>What's Next?</h2>
                    <p className="text-secondary fs-4" style={{ fontWeight: '400' }}>
                        We're prepping your numbers for production. You'll receive a tracking link as soon 
                        as your order ships. Have questions? <a target="_blank" href="https://precisionservicesgroup.com/contact.html">Contact Us</a> for support.
                    </p>
                    <p className="text-secondary fs-4" style={{ fontWeight: '400' }}>Rady to race? Make sure your crew is greared up too!</p>
                    <div className="mt-4 fs-4" style={{ width: '300px' }}>
                        <button className="scoraBtn p-3 rounded-5 w-100" onClick={() => navigate("/scora")}>SHOP MORE GEAR</button>
                    </div>
                </section>
            </div>
        </div>
    );
}